/* fw-search-suggest — live suggestions under the desktop search pill
   (snippets/fw-header-search.liquid). Asks Shopify's predictive search for
   the theme's own `search-results` section — the same markup the mobile
   drawer shows, so "show vendor / price" settings keep working — and puts
   it in the panel inside the form. No dependency on theme.js. The stock
   "Alle Ergebnisse" button in that markup is a submit button, so inside
   this form it simply runs the full search. */
(function () {
  'use strict';
  if (!('fetch' in window) || !('AbortController' in window) || !('URLSearchParams' in window)) return;
  var forms = document.querySelectorAll('form.fw-header-search[data-suggest-url]');
  Array.prototype.forEach.call(forms, function (form) {
    var input = form.querySelector('input[type="search"]');
    var panel = form.querySelector('[data-fw-search-results]');
    if (!input || !panel) return;
    var url = form.getAttribute('data-suggest-url');
    var timer = null;
    var controller = null;
    var shownFor = '';

    function hide() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }
    function close() {
      hide();
      panel.innerHTML = '';
      shownFor = '';
    }
    function show(html, term) {
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      shownFor = term;
    }
    function reopen() {
      if (shownFor && input.value.trim() === shownFor) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    }
    function load(term) {
      if (controller) controller.abort();
      controller = new AbortController();
      var params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'query,product,collection');
      params.set('resources[limit]', '4');
      params.set('resources[limit_scope]', 'each');
      params.set('section_id', 'search-results');
      fetch(url + '?' + params.toString(), { signal: controller.signal, credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('predictive search ' + res.status);
          return res.text();
        })
        .then(function (text) {
          if (input.value.trim() !== term) return; // answer to an older keystroke
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-search-results');
          var html = section ? section.innerHTML.trim() : '';
          if (!html) { close(); return; }
          show(html, term);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          close();
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) { close(); return; }
      timer = setTimeout(function () { load(term); }, 250);
    });
    input.addEventListener('focus', reopen);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowDown' && !panel.hidden) {
        var first = panel.querySelector('a, button');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });
    document.addEventListener('focusin', function (e) {
      if (!form.contains(e.target)) hide();
    });
    form.addEventListener('submit', hide);
  });
})();
